export const PP_ACCEPTED = '1';
export const EXCLUSIVITY = '32';
export const PETS_ALLOWED = '9';
